const APPLICANT_DOCUMENT_TYPES = {
    DOCUMENT: "document"
};

export default APPLICANT_DOCUMENT_TYPES;